import { cn } from "@omni/utils/styles";

import { useECommerceContext } from "@/components/Product/ECommerce/context/eCommerce.context";
import { useECommerceProduct } from "@/components/Product/ECommerce/hooks/useECommerceProduct.hook";
import { WishlistButtonContainer } from "@/components/Wishlist/WishlistButton/WishlistButton.container";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { toTrackingProduct } from "@/services/tracking/mappers/product.mapper";
import { useIsClientSide } from "@/utils/hooks/isClient.hook";

const WishlistButton = () => {
    const { t } = useGranite();
    const isClient = useIsClientSide();
    const { sku, isAdditionalService } = useECommerceProduct();
    const { product } = useECommerceContext();

    return (
        <>
            {!isAdditionalService && isClient && (
                <WishlistButtonContainer
                    className={cn("tw:text-[1.6rem]! tw:xl:text-base! tw:pr-0")}
                    iconSize={"la-1x"}
                    sku={sku}
                    product={toTrackingProduct(product)}
                    labelClassName={cn("tw:hidden tw:xl:inline-block")}
                    label={(isProductInWishlist) =>
                        isProductInWishlist
                            ? t("ecommerce.wishlistButton.remove")
                            : t("ecommerce.wishlistButton.add")
                    }
                />
            )}
        </>
    );
};

export { WishlistButton };
